var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Profile',[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('update:mini', !_vm.mini)}}},[_c('v-icon',[_vm._v("mdi-chevron-left")])],1)],1),_c('List',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }